module.exports = __webpack_public_path__ + "img/reports-logo-active.85a103c9.svg";